import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";

type ITypeaheadRequest = {
    url: string;
    query: string;
};

export const typeaheadApi = createApi({
    reducerPath: "typeaheadApi",
    baseQuery,
    endpoints: (builder) => ({
        getSuggestions: builder.query<unknown, ITypeaheadRequest>({
            query: ({ url, query }) => ({
                url,
                method: "POST",
                body: { query },
            }),
            keepUnusedDataFor: 300,
        }),
    }),
});

export const { useLazyGetSuggestionsQuery } = typeaheadApi;
